module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 82.ea84832c.png";